import React from "react";

export function SectionHeading({ kicker, title, accent, align = "left", testid }) {
  return (
    <div
      className={`flex flex-col ${align === "center" ? "items-center text-center" : "items-start text-left"} gap-4`}
      data-testid={testid}
    >
      {kicker && (
        <span className="text-[11px] tracking-[0.4em] uppercase text-gold font-body">
          {kicker}
        </span>
      )}
      <h2 className="font-heading text-4xl md:text-5xl lg:text-6xl text-white leading-[1.05]">
        {title}{" "}
        {accent && (
          <span className="font-brand text-pink-luxe text-5xl md:text-6xl lg:text-7xl block md:inline">
            {accent}
          </span>
        )}
      </h2>
    </div>
  );
}

export function PageHero({ kicker, title, accent, subtitle, image, testid }) {
  return (
    <section
      className="relative min-h-[60vh] md:min-h-[70vh] flex items-end overflow-hidden grain"
      data-testid={testid}
    >
      <div className="absolute inset-0">
        <img
          src={image}
          alt=""
          className="w-full h-full object-cover opacity-60"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/50 to-black" />
      </div>
      <div className="relative max-w-7xl mx-auto px-6 md:px-10 pb-16 md:pb-24 w-full">
        {kicker && (
          <span className="text-[11px] tracking-[0.4em] uppercase text-gold font-body">
            {kicker}
          </span>
        )}
        <h1 className="font-heading text-5xl md:text-7xl text-white mt-4 leading-[1.02] max-w-3xl">
          {title}{" "}
          {accent && (
            <span className="font-brand text-pink-luxe text-6xl md:text-8xl">
              {accent}
            </span>
          )}
        </h1>
        {subtitle && (
          <p className="text-white/75 font-heading text-lg md:text-xl mt-6 max-w-2xl leading-relaxed">
            {subtitle}
          </p>
        )}
      </div>
    </section>
  );
}
